const ALLOWED_REDIRECT_HOSTS = String(
  import.meta.env.VITE_ALLOWED_REDIRECT_HOSTS || "",
)
  .split(",")
  .map((host) => host.trim().toLowerCase())
  .filter(Boolean);

const DEFAULT_ALLOWED_REDIRECT_HOST_SUFFIXES = [".indusindnipponlife.com"];

const isAllowedHost = ({ host, hostname }) => {
  const normalizedHost = String(host || "").trim().toLowerCase();
  const normalizedHostname = String(hostname || "").trim().toLowerCase();
  if (!normalizedHost || !normalizedHostname) return false;

  const isEnvAllowed = ALLOWED_REDIRECT_HOSTS.some((allowedHost) => {
    if (!allowedHost) return false;
    if (allowedHost === normalizedHost || allowedHost === normalizedHostname) {
      return true;
    }
    if (allowedHost.startsWith("*.")) {
      const suffix = allowedHost.slice(1); // ".example.com"
      return normalizedHostname.endsWith(suffix);
    }
    if (allowedHost.startsWith(".")) {
      return normalizedHostname.endsWith(allowedHost);
    }
    return false;
  });

  if (isEnvAllowed) return true;

  const isDefaultAllowed = DEFAULT_ALLOWED_REDIRECT_HOST_SUFFIXES.some((suffix) =>
    normalizedHostname.endsWith(String(suffix).toLowerCase()),
  );

  if (isDefaultAllowed) return true;

  if (typeof window !== "undefined" && window.location?.host) {
    return (
      normalizedHost === String(window.location.host).trim().toLowerCase() ||
      normalizedHostname === String(window.location.hostname).trim().toLowerCase()
    );
  }
  return false;
};

export const getSafeRedirectUrl = (candidateUrl) => {
  if (!candidateUrl || typeof candidateUrl !== "string") return null;
  try {
    const parsed = new URL(candidateUrl, window.location.origin);
    if (!["https:", "http:"].includes(parsed.protocol)) return null;
    if (!isAllowedHost({ host: parsed.host, hostname: parsed.hostname })) return null;
    return parsed.toString();
  } catch {
    return null;
  }
};
